<template>
  <Modal
    event-tracking-source="sign in popup"
    @close="openModal(false)"
  >
    <div class="w-full h-full px-6 pt-10 overflow-y-auto sm:px-12 sm:pb-12 login-container">
      <div class="mb-6 sm:mb-10">
        <div class="text-3xl font-semibold text-center text-4d4d4d">
          Welcome back
        </div>
        <p class="hidden text-lg text-center sm:block text-4d4d4d">
          Sign in to your account
        </p>
      </div>
      <LoginForm
        :social-error="socialError"
        click-source="sign in popup"
        @trackLoginEvent="trackLoginEvent"
      />
    </div>
  </Modal>
</template>

<script>
import LoginForm from '@/components/LoginForm/index.vue';
import Modal from './Modal.vue';

export default {
  components: {
    Modal,
    LoginForm,
  },
  props: {
    socialError: {
      type: String,
      default: '',
    },
  },
  watch: {
    socialError(newVal) {
      this.globalError = newVal;
    },
  },
  methods: {
    trackLoginEvent(userId) {
      this.$emit('trackLoginEvent', userId);
    },
    openModal(open) {
      this.$store.dispatch('setOpenSignInModal', { open, clickSource: 'sign in popup' });
    },
  },
};
</script>

<style scoped>
.text-4d4d4d {
  color: #4d4d4d;
}

>>> .modal-body {
  border-radius: 12px;
}

@screen sm {
  .login-container {
    max-width: 475px;
  }

}
</style>
